import { OpenActionModalPayload } from 'actions/openModalAction';
import { HpAction, HpTemplateActionTypes } from '../actions/actionTypes';
import { PolicyState, getInitialState } from './initialState';
import { ReducerProcessor } from './reducerProcessor';

const processor = new ReducerProcessor<PolicyState, HpTemplateActionTypes>('policy');

processor.add('RENEW_POLICY_LOADING', (state) => {
  return {
    ...state,
    renewPolicyLoading: true
  };
});

processor.add('RENEW_POLICY_SUCCESS', (state, action) => {
  const renewalPaymentReference = action.payload;
  return {
    ...state,
    renewPolicyLoading: false,
    renewPolicySuccess: true,
    renewalPaymentReference
  };
});

processor.add('RENEW_POLICY_ERROR', (state) => {
  return {
    ...state,
    renewPolicyLoading: false,
    renewPolicyError: true
  };
});

processor.add<HpAction<OpenActionModalPayload>>('OPEN_ACTION_MODAL', (state, action) => {
  const payload = action.payload;
  if (!payload) {
    return state;
  }

  return {
    ...state,
    actionModal: {
      isOpen: true,
      modalType: payload.modalType,
      alertMessage: payload.modalType === 'agent-feature-unavailable' ? payload.alertMessage : undefined
    }
  };
});

processor.add('CLOSE_ACTION_MODAL', (state) => {
  return {
    ...state,
    actionModal: {
      isOpen: false
    }
  };
});

export function policyReducer(state: PolicyState = getInitialState().policy, action: HpAction<any>): PolicyState {
  return processor.process(state, action);
}
